import { useEffect, useState } from "react";
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { axiosInstanceB2B, RootState } from '@share/utils';
import { ILoginState, IPasswordState, change } from '@share/store/slices';

import SideNav from "../../components/dashboard/side-nav/component";
import UpdatePassword from "./update-password";
import { IUser } from "@share/common-types";
import NotificationSettings from "./notification-settings";
import TwoFactorSettings from "./two-factor-settings";
import { Spin } from "antd";

interface IMapStateToProps {
  loginStore: ILoginState;
  passwordStore: IPasswordState;
}

interface IProps extends IMapStateToProps, RouteComponentProps, WrappedComponentProps { }

function AccountSettingsComponent(props: IProps) {
  const { loading } = props.passwordStore;
  const [resetPassLoading, setResetPassLoading] = useState<boolean>(false);
  const [userData, setUserData] = useState<IUser>();

  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const currentUser = loginStore.user;

  const dispatch = useDispatch();

  const onFinish = async (values: any) => {
    setResetPassLoading(loading);
    values.userId = currentUser?.userId;
    delete values.confirmNewPassword;
    try {
      dispatch(change(values.currentPassword, values.newPassword))
    } catch (e) {
    } finally {
      setResetPassLoading(false);
    }
  };

  const fetchUserData = async () => {
    const getUser = await axiosInstanceB2B.get(`/identity/users/${currentUser?.userId}`);
    setUserData(getUser.data);
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <Spin spinning={!userData}>
              <UpdatePassword
                handleSubmit={onFinish}
                resetPassLoading={resetPassLoading}
              />

              {userData ? <TwoFactorSettings user={userData} fetchUserData={fetchUserData} /> : null}
              
              <NotificationSettings />
            </Spin>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
    passwordStore: state.passwordStore
  };
};

const ComponentIntl = injectIntl(AccountSettingsComponent);
const AccountSettings = connect(mapStateToProps)(withRouter(ComponentIntl));
export default AccountSettings;